// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".picker__elements{margin:0 -.3125rem}.picker .picker-item{margin:0 .3125rem}.picker--error .picker__elements{--border-size:.125rem;position:relative}.picker--error .picker__elements:after{border:var(--border-size) solid var(--error-border);bottom:calc(var(--border-size)*-1);content:\"\";left:calc(var(--border-size)*-1);pointer-events:none;position:absolute;right:calc(var(--border-size)*-1);top:calc(var(--border-size)*-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
